import { createSlice } from '@reduxjs/toolkit';
import { fetchCatalog } from './thunks';

export type ICatalogState =
  | {
      state: 'loading';
    }
  | {
      state: 'loaded';
      model: datasources.IEnhancedCatalog;
    }
  | {
      state: 'error';
      error: string;
    };

const stateSlice = createSlice({
  name: 'catalog',
  initialState: {
    state: 'loading',
  } as ICatalogState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchCatalog.pending, () => {
        return {
          state: 'loading',
        };
      })
      .addCase(fetchCatalog.fulfilled, (_state, { payload }) => {
        return {
          state: 'loaded',
          model: payload,
        };
      })
      .addCase(fetchCatalog.rejected, (_state, action) => {
        return {
          state: 'error',
          error: action.payload || 'Error while loading the catalog',
        };
      });
  },
});

// uncomment to export actions from the slice.
// export const { action } = stateSlice.actions;

export default stateSlice;
